import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../../../models/User';

@Component({
  selector: 'domain-cookie-banner',
  templateUrl: './domain-cookie-banner.html',
  styleUrls: ['./domain-cookie-banner.css']
})
export class DomainCookieBanner implements OnInit {
  @Input() data: any;

  preview: string;

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(private userService: User) {}

  ngOnInit() {}

  showImage() {
    this.preview = this.preview ? '' : 'show';
  }
}
